import { api, CACHE_TIME, getHeaders } from '@/api';
import type { TenantSettingRecord } from '@/features/tenant-settings/consts/registry';
import { queryOptions } from '@tanstack/react-query';

interface ApiResponse<T> {
  Data?: T | null;
  Error?: boolean;
  Errors?: string[];
}

export const fetchTenantSettings = async (): Promise<TenantSettingRecord[]> => {
  const response = await api.get<ApiResponse<TenantSettingRecord[]>>('md/api/TenantSettings', getHeaders());
  const parsed = response.data;
  return parsed.Data ?? [];
};

export const tenantSettingsQueries = {
  all: ['tenant-settings'] as const,
  list: () =>
    queryOptions({
      queryKey: tenantSettingsQueries.all,
      queryFn: fetchTenantSettings,
      staleTime: CACHE_TIME.STALE,
      gcTime: CACHE_TIME.GC
    })
};
